import { render, staticRenderFns } from "./BookInfoDialog.vue?vue&type=template&id=36b9a704&scoped=true"
import script from "./BookInfoDialog.vue?vue&type=script&lang=js"
export * from "./BookInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./BookInfoDialog.vue?vue&type=style&index=0&id=36b9a704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9a704",
  null
  
)

export default component.exports